import angular from 'angular';
import {
  pmDataService,
  reportsDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './board-approve-dialog.controller';
import template from './board-approve-dialog.html';
import messageTpl from './analysis-date.messages.html';

class dialogService {
  getOptions($event, {
    policyDocumentId,
    documentName,
    isNavantaUser,
    users
  }) {
    return {
      controller,
      controllerAs: 'boardApproveDialogVM',
      locals: {
        policyDocumentId,
        documentName,
        isNavantaUser,
        users
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.boardApproveDialog', [
  alerts,
  pmDataService,
  ssDialogService,
  loaderService,
  reportsDataService,
])
  .service('pmBoardApproveDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('analysis-date.messages.html', messageTpl);
  })
  .name;
